export default __webpack_public_path__ + "static/image-a1ad0ec66ecd6857a1d0584c262824de.png";